<app-confirmation-dialog
  layout="start"
  [title]="isArabic() ? 'إزالة المنتج من الطلب' : 'Drop Product From Order'"
  [description]="
    isArabic()
      ? 'سيتم إزالة هذا المنتج من الطلب. سيتم تحديث ملخص الطلب. هل تريد المتابعة؟'
      : 'This product will be removed from the order. The order summary will be updated. Do you want to proceed?'
  "
  [confirmContent]="isArabic() ? 'تأكيد' : 'Confirm'"
  [cancelContent]="isArabic() ? 'إلغاء' : 'Cancel'"
  [isLoading]="isLoading()"
  (onSubmit)="onSubmit()"
  (onCancel)="onCancel()" />
